import { Component, OnInit, HostListener, Renderer2, Inject } from '@angular/core';
import { CognitoService } from 'src/service/cognito.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { signOut, fetchAuthSession } from 'aws-amplify/auth';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';
const HASHKEY = "B@j@j@123%&~SSO*7&%";

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css'],
})
export class SignUpComponent implements OnInit {
  issignUp: boolean = true;
  confirmationCode: string = '';
  isSignUpComplete: boolean = false;
  isCodeSent: boolean = false;
  password: string = '';
  email: string = '';
  mobile: string = '';
  name: string = '';
  otp: string = '';
  username: string = '';
  clientId: any = '';
  signedInUserEmail: any = '';
  signInErrorMessage: any = '';
  UserSignIn: boolean = false;
  savedUserEmail: any = '';
  userSession: any = '';
  token: any = '';
  loader: boolean = false;
  mobileWithCountryCode: any = '';
  showOtpField: boolean = false;
  getotp: boolean = true;
  isTimer: boolean = false;
  isResend: boolean = false;
  timeleft: number = 0;
  intervalId: any;
  resendBtnTimer: number = 0;
  clickedResend: number = 0;
  resendotp: boolean = false;
  otpverify: boolean = false;
  otpverifyMsg: boolean = false;
  isOtpAlreadyVerified: boolean = false;
  showPassword: boolean = false;
  showPopup: boolean = false;
  otpsentmsg: boolean = false;
  activeTab: any = 'sign-up';
  b2b_insurance = environment.b2b_insurance;
  retirment_clientid = environment.retirment_clientid;
  surveypro_clientid = environment.surveypro_clientid;
  bqdashboard_clientid = environment.bqdashboard_clientid;
  post_retirement_clientid = environment.post_retirement_clientid;
  b2b_india_bonds_clientid = environment.b2b_india_bonds_clientid;
  DatacloudWM_clientid = environment.DatacloudWM_clientid;
  fpb2b_clientid = environment.fpb2b_clientid;
  digitalrm_clientid = environment.digitalrm_clientid;



  constructor(private cognitoService: CognitoService, private router: Router, private route: ActivatedRoute, private renderer: Renderer2,
    @Inject(DOCUMENT) private doc: Document) { }

  @HostListener('document:contextmenu', ['$event'])
  onRightClick(event: MouseEvent) {
    event.preventDefault();
  }

  async ngOnInit() {
    this.setCanonicalURL();
    this.route.queryParams.subscribe((params) => {
      this.clientId = params['clientId'] || null;
      if (this.clientId) {
        this.cognitoService.configureOAuth(this.clientId);
        if (this.clientId === this.b2b_insurance || this.clientId === this.retirment_clientid || this.clientId === this.surveypro_clientid || this.clientId === this.bqdashboard_clientid || this.clientId === this.post_retirement_clientid || this.clientId === this.b2b_india_bonds_clientid || this.clientId === this.DatacloudWM_clientid || this.clientId === this.fpb2b_clientid || this.clientId === this.digitalrm_clientid) {
          this.router.navigate(['/sign-in'], {
            queryParams: { clientId: this.clientId },
          });
        }
      }
    });

    try {
      const authSession = await fetchAuthSession();
      this.userSession = authSession.userSub;
      this.savedUserEmail = authSession.tokens?.idToken?.payload['email'];
      if (this.savedUserEmail || this.userSession) {
        this.UserSignIn = true;
        this.signedInUserEmail = this.savedUserEmail;
      } else {
        this.UserSignIn = false;
      }
    } catch (error) {
      console.error('Error fetching auth session:');
    }
    this.email = '';
  }

setCanonicalURL() {
  const url = window.location.origin; 

  let link: HTMLLinkElement =
    document.querySelector("link[rel='canonical']") || document.createElement('link');

  link.setAttribute('rel', 'canonical');
  link.setAttribute('href', url + '/');
  document.head.appendChild(link);
}


  showError(message: string, timeout: number = 4000) {
    this.signInErrorMessage = message;
    this.loader = false;
    setTimeout(() => {
      this.signInErrorMessage = '';
    }, timeout);
  }

  async onSignUp() {
    let jscd: any = window[<any>'jscd'];

    if (!this.name?.trim()) return this.showError('Name is required to sign up');
    if (!this.email?.trim()) return this.showError('Email is required to sign up');
    if (this.validateEmailAddress() === 0) return this.showError('Please enter a valid email address');

    this.mobileWithCountryCode = '+91' + this.mobile;
    if (!this.mobile || this.mobile.length !== 10) return this.showError('Please enter a valid 10-digit mobile number');
    if (!this.password?.trim()) return this.showError('Password is required to sign up');

    if (!this.showOtpField) return this.showError('OTP is required, please click on Generate OTP');
    if (this.showOtpField && !this.otp.trim()) return this.showError('OTP is required');

    const isOtpValid = await this.verifyotp();
    if (!isOtpValid) {
      this.resendotp = true;
      return this.showError('OTP verification failed. Please try again.');
    }

    try {
      const response = await this.cognitoService.handleSignUp({
        password: this.password,
        email: this.email,
        name: this.name,
        mobile: this.mobileWithCountryCode,
      });
      if (response?.nextStep) {
        this.cognitoService.b2cInsertapi({ email: this.email }).subscribe();
        this.signInErrorMessage = '';
        this.loader = true;
        setTimeout(() => {
          this.loader = false;
          this.issignUp = false;
          this.isSignUpComplete = true;
        }, 2000);
        await this.logUserEvent(this.email, 'code sent for signup', 'pass', '', 1);
      }
      this.resendForEmail();
    } catch (error: any) {
      if (error.message.includes('User pool client') && error.message.includes('does not exist')
      ) {
        this.showError('User pool client does not exist.');
      } else if (error.message.includes('Password did not conform with policy') && error.message.includes(' Password not long enough')
      ) {
        this.showError('Password must be at least 8 characters long');
      } else {
        this.showError(error.message);
      }
    }
  }

  validateEmailAddress(): number {
    if (!this.email) return 0;
    const email = this.email.trim().toLowerCase();
    const lastDot = email.lastIndexOf('.');
    const isValid =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email) &&
      lastDot !== -1 &&
      email.length - lastDot > 2;
    return isValid ? 1 : 0;
  }

  async onConfirmSignUp() {
    if (!this.confirmationCode || this.confirmationCode.trim() === '') {
      this.showError('Please enter verification code');
      return;
    }
    try {
      await this.cognitoService.handleSignUpConfirmation({
        username: this.mobileWithCountryCode,
        confirmationCode: this.confirmationCode,
      });
    } catch (error: any) {
      if (error.message === 'User cannot be confirmed. Current status is CONFIRMED') {
        this.showPopup = true;
        this.isSignUpComplete = false;
        await this.logUserEvent(this.email, 'code verify for signup', 'pass', '', 1);
      } else {
        this.showError('Invalid verification code');
        await this.logUserEvent(this.email, 'code verify for signup', 'fail', 'invalid code for signup', 1);
      }
    }
  }

  LoginGetStarted() {
    this.issignUp = true;
    this.email = '';
    this.password = '';
    this.name = '';
    this.signInErrorMessage = '';
    this.isSignUpComplete = false;
    this.isCodeSent = false;
    this.router.navigate(['/sign-in'], {
      queryParams: { clientId: this.clientId },
    });
  }

  async handleSignOut() {
    this.loader = true;
    setTimeout(async () => {
      this.loader = false;
      await signOut();
      this.UserSignIn = false;
      location.reload();
    }, 4000);
  }


  async onGoogleSignIn() {
    try {
      await this.cognitoService.handleGoogleSignIn();
    } catch (error) {
      console.error('Google Sign-In error:');
    }
  }


  forsignin() {
    this.router.navigate(['/sign-in'], {
      queryParams: { clientId: this.clientId },
    });
  }

  async resendForEmail() {
    this.confirmationCode = '';
    this.mobileWithCountryCode = '+91' + this.mobile;
    try {
      await this.cognitoService.resendOTP(this.mobileWithCountryCode);
    } catch (error) {
      this.showError('Failed to resend OTP');
    }
  }

  async resendCodeForEmail() {
    this.confirmationCode = '';
    this.mobileWithCountryCode = '+91' + this.mobile;
    try {
      await this.cognitoService.resendOTP(this.mobileWithCountryCode);
      await this.logUserEvent(this.email, 'resend code for signup', 'pass', '', 1);
      this.showError('OTP sent successfully!');
    } catch (error) {
      this.showError('Failed to resend OTP');
    }
  }

  MobileNumberChange(newMobile: string) {
    this.mobile = newMobile;
    const numberLength = newMobile.length;

    if (numberLength === 10) {
      this.getotp = true;
      this.isOtpAlreadyVerified = false;
    } else {
      this.getotp = false;
      this.showOtpField = false;
      this.otp = '';
      this.resendotp = false;
      this.isOtpAlreadyVerified = false;
    }
  }

  sendotp() {
    const numberLength = this.mobile.length;
    if (numberLength === 10) {
      this.initiateOTPSignIn();
    } else {
      this.showError('Please enter a valid 10-digit mobile number');
    }
  }

  startTimer() {
    clearInterval(this.intervalId);
    this.timeleft = 20;
    this.isTimer = true;
    this.isResend = false;

    this.intervalId = setInterval(() => {
      if (this.timeleft === 0) {
        clearInterval(this.intervalId);
        this.isTimer = false;
        if (!this.otpverify) {
          this.resendotp = true;
        }
      } else {
        this.timeleft -= 1;
      }
    }, 1000);
  }

  initiateOTPSignIn() {
    this.loader = true;
    this.getotp = false;
    this.otp = '';
    this.resendotp = false;
    this.startTimer();

    const obj = {
      mobile: '+91' + this.mobile,
    };
    const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(obj), HASHKEY).toString();
    this.cognitoService.sendOtp({ mobile: ciphertext }).subscribe(async (data: any) => {
      const responseBody = typeof data.body === 'string' ? JSON.parse(data.body) : data.body;

      if (responseBody.success) {
        this.showOtpField = true;
        this.otpsentmsg = true;
        this.loader = false;
        await this.logUserEvent(this.mobile, 'otp sent for signup', 'pass', '', 1);
      } else {
        this.getotp = true;
        this.showOtpField = false;
        this.showError(responseBody.message || 'Too many attempts. Try again after 1 hour.');
      }
    }, (error) => {
      this.loader = false;
      this.showError('Something went wrong while sending OTP.');
      console.error('OTP Error:', error);
    });
  }


  onOtpChange(otpValue: string) {
    this.otp = otpValue;
    this.isOtpAlreadyVerified = false;
    if (otpValue.length === 6) {
      this.verifyotp();
    } else {
      this.resendotp = true;
      this.otpverifyMsg = false;
    }
  }

  verifyotp(): Promise<boolean> {
    return new Promise((resolve) => {
      const obj = {
        user_id: '+91' + this.mobile,
        otp: this.otp,
      };
      const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(obj), HASHKEY).toString();

      this.cognitoService.newverifyOtp({ data: ciphertext }).subscribe(
        async (data: any) => {
          // Parse body correctly
          const responseBody = typeof data.body === 'string' ? JSON.parse(data.body) : data.body;
          console.log('Verify OTP Response:', responseBody);

          // Access success and message directly
          const otpSuccess = responseBody?.success;
          if (otpSuccess) {
            this.otpverifyMsg = true;
            this.otpsentmsg = false;
            this.signInErrorMessage = '';
            this.otpverify = true;
            this.isTimer = false;
            this.resendotp = false;
            this.isOtpAlreadyVerified = true;

            setTimeout(() => {
              this.otpverifyMsg = false;
            }, 4000);

            await this.logUserEvent(this.mobile, 'otp verify for signup', 'pass', '', 1);
            resolve(true);
          } else {
            this.isTimer = false;
            this.resendotp = true;
            this.showError(responseBody?.message || 'OTP is invalid, please try again'); // ✅ fixed
            await this.logUserEvent(this.mobile, 'otp verify for signup', 'fail', 'invalid otp for signup', 1);
            resolve(false);
          }
        },
        (error) => {
          console.error('Error verifying OTP:', error);
          this.showError('Error verifying OTP');
          resolve(false);
        }
      );
    });
  }




  validateName() {
    if (!this.name || this.name.trim() === '') {
      this.signInErrorMessage = 'Name is required to sign up';
      setTimeout(() => {
        this.signInErrorMessage = '';
      }, 4000);
    }
  }

  validateEmail() {
    if (!this.email || this.email.trim() === '') {
      this.signInErrorMessage = 'Email is required to sign up';
    } else if (this.validateEmailAddress() === 0) {
      this.signInErrorMessage = 'Please enter a valid email address';
    }
    setTimeout(() => {
      this.signInErrorMessage = '';
    }, 4000);
  }

  validateMobileNumber() {
    if (!this.mobile || this.mobile.length !== 10) {
      this.signInErrorMessage = 'Please enter a valid 10-digit mobile number';
      setTimeout(() => {
        this.signInErrorMessage = '';
      }, 4000);
    }
  }

  validateOtp() {
    if (this.showOtpField && this.otp.trim() === '') {
      this.signInErrorMessage = 'OTP is required';
      setTimeout(() => {
        this.signInErrorMessage = '';
      }, 4000);
    }
  }

  validatePassword() {
    if (!this.password || this.password.trim() === '') {
      this.signInErrorMessage = 'Password is required to sign up';
      setTimeout(() => {
        this.signInErrorMessage = '';
      }, 4000);
    }
  }

  async logUserEvent(
    userid: string,
    event_type: string,
    event_result: string,
    event_error: string,
    AppType: number
  ) {
    let jscd: any = window[<any>'jscd'];
    // const ipResponse = await this.cognitoService.getIpAddress().catch((err) => {
    //   console.error('Failed to fetch IP address:', err);
    //   return null;
    // });
    const userevntobj = {
      userid,
      event_type,
      event_result,
      event_error,
      AppType,
      client_id: this.clientId,
      // ip_address: ipResponse || 'Unknown',
      ip_address:'Unknown',
      device: `${jscd?.browser} ${jscd?.os} ${jscd?.osVersion}`,
    };
    this.cognitoService.UserEventHistory(userevntobj).subscribe();
  }
}
